import Vue from 'vue';
import Inputmask from 'inputmask';
import { setPhoneFormat, resetPhoneFormat } from '@src/js/inputMasks.js';
import Button from '@components/ui/button.vue';

import { mapMutations, mapState, mapActions } from 'vuex';

let PageComponent = {
  name: 'personal',
  data() {
    return {
      id: null,
      template: '<p>default temp</p>',
      personalInfo: [],
      personalInfoBuffer: [],
      deliveryAddress: [],
      notification: {},
      personalInfoEdit: false,
      addressInfoEdit: false,
      newAddress: '',
      newAddressError: false,
      newAddressComment: '',
      newAddressPhone: '',
      newAddressPhoneError: false,
      newAddressBlock: false,
      activeEditAdressBock: '',
    };
  },
  components: {
    't-button': Button,
  },
  computed: {
    ...mapState('api', [
      'addNewAddressApi',
      'updateProfile',
      'deleteOldAddress',
      'profileNotifications',
      'addAddress',
      'updAddress',
      'deleteAddress',
      'updateValidate',
      'sendCode',
      'setToken',
      'setConfirmCodeType',
      'setSignUpInfo',
      'setUpdateProfileCallback',
    ]),
  },
  watch: {
    personalInfo: function(newV, oldV) {
      setTimeout(() => {
        Object.keys(this.$refs).forEach((item) => {
          this.inputResize(item);
        });
      }, 0);
    },
  },
  methods: {
    ...mapMutations('params', [
      'toogleChangePassword',
      'toggleRightMenu',
      'toogleCodeConfirm',
    ]),
    ...mapActions('api', ['fetchRequest']),
    setTemplate: function(template) {
      this.template = template.data;
    },
    setData: function(data, to) {
      this.setTemplate(data);
    },
    inputResize: function(id) {
      function resize(element) {
        if (
          element.querySelector('#hide') &&
          element.querySelector('textarea')
        ) {
          element.querySelector('#hide').textContent = element.querySelector(
            'textarea'
          ).value;
          element.querySelector('textarea').style.width =
            element.querySelector('#hide').offsetWidth + 50 + 'px';

          element.querySelector('textarea').style.height =
            element.querySelector('#hide').offsetHeight + 'px';
        }
      }
      if (this.$refs[id][0]) {
        resize(this.$refs[id][0]);
      } else {
        resize(this.$refs[id]);
      }
    },
    // Address list methods
    editAddressInfo: function(id) {
      this.newAddressBlock = false;
      const item = this.deliveryAddress.find((item) => item.id == id);

      if (this.activeEditAdressBock != id) {
        this.activeEditAdressBock = id;
        this.newAddress = item.value;
        this.newAddressComment = item.comment;
        this.newAddressPhone = item.phone;
      } else this.activeEditAdressBock = '';

      if (!this.activeEditAdressBock) {
        this.fetchRequest({
          url: this.updAddress,
          form: this.form({
            addressId: id,
            address: this.newAddress,
            comment: this.newAddressComment ? this.newAddressComment : null,
            phone: this.newAddressPhone ? this.newAddressPhone : null,
          }),
          success: (data) => {
            console.log('success', data);
            item.value = this.newAddress;
            item.comment = this.newAddressComment
              ? this.newAddressComment
              : null;
            item.phone = this.newAddressPhone ? this.newAddressPhone : null;
            this.clearNewAddress();
          },
          error: (e) => {
            console.log('error', e);
            this.clearNewAddress();
          },
        });
      }
    },
    delAddress: function(addressId) {
      this.fetchRequest({
        url: this.deleteAddress,
        form: this.form({
          addressId: addressId,
        }),
        success: (data) => {
          console.log('success', data);
          this.deliveryAddress = this.deliveryAddress.filter(
            (item) => item.id !== addressId
          );
        },
        error: (e) => {
          console.log('error', e);
        },
      });
    },
    addNewAddress: function() {
      if (!this.newAddress) {
        this.newAddressError = true;
        return;
      }

      console.log('this.newAddressPhone.length', this.newAddressPhone.length);
      if (this.newAddressPhone.length > 0 && this.newAddressPhone.length < 17) {
        this.newAddressPhoneError = true;
        return;
      }

      this.fetchRequest({
        url: this.addNewAddressApi,
        form: this.form({
          address: this.newAddress,
          comment: this.newAddressComment ? this.newAddressComment : null,
          phone: this.newAddressPhone ? this.newAddressPhone : null,
        }),
        success: (data) => {
          if (data.body.success) {
            this.deliveryAddress.push({
              id: data.body.id,
              value: this.newAddress,
              comment: this.newAddressComment ? this.newAddressComment : null,
              phone: this.newAddressPhone ? this.newAddressPhone : null,
            });

            this.clearNewAddress();
            this.toggleNewAddressBlock();
          }
        },
        error: (e) => {
          this.clearNewAddress();
        },
      });
    },

    toggleNewAddressBlock: function() {
      if (this.activeEditAdressBock) {
        this.activeEditAdressBock = false;
        this.newAddress = '';
        this.newAddressComment = '';
        this.newAddressPhone = '';
        this.newAddressError = false;
      }

      this.newAddressBlock = !this.newAddressBlock;
    },
    toggleModalInterface: function(id) {
      this.$refs[id][0].classList.toggle('open');
    },
    // Personal info methods
    editPersonalInfo: function() {
      this.personalInfoEdit = !this.personalInfoEdit;

      setTimeout(() => {
        Object.keys(this.$refs).forEach((item) => {
          this.inputResize(item);
        });
      }, 0);
    },
    setPersonalInfoBuffer: function() {
      this.personalInfoBuffer = this.personalInfo.map((item) => {
        return { ...item };
      });
    },
    savePersonalInfo: function() {
      let result = {};

      this.personalInfo.forEach((item) => {
        if (item.type == 'personalname') {
          result.username = item.value;
        }
        if (item.type == 'license') {
          result.license = item.value;
        }
        if (item.type == 'phone') {
          result.phone = this.createPhone(item.value);
        }
      });

      this.fetchRequest({
        url: this.updateValidate,
        form: this.form(result),
        success: (data) => {
          console.log('savePersonalInfo validate success', data);
          if (data.body.success) {
            if (!data.body.isNeedSms) {
              this.fetchRequest({
                url: this.updateProfile,
                form: this.form(result),
                success: (data) => {
                  console.log('savePersonalInfo update success', data);
                  if (data.body.success) {
                    this.editPersonalInfo();
                  }
                },
                error: (e) => {},
              });
            } else {
              this.fetchRequest({
                url: this.sendCode,
                form: this.form({ phone: result.phone }),
                success: (data) => {
                  console.log('success send code', data);
                  this.setToken(data.body.token);
                  this.setConfirmCodeType('UPDATE_PROFILE');
                  this.setSignUpInfo(result);
                  this.toggleRightMenu();
                  this.toogleCodeConfirm();
                  this.setUpdateProfileCallback(() => {
                    this.fetchRequest({
                      url: this.updateProfile,
                      form: this.form({ ...result, token: data.body.token }),
                      success: (data) => {
                        console.log('savePersonalInfo update success', data);
                        if (data.body.success) {
                          this.editPersonalInfo();
                        }
                      },
                      error: (e) => {},
                    });
                  });

                  /*
                  if (data.body.token) {
                    this.fetchRequest({
                      url: this.updateProfile,
                      form: this.form({ ...result, token: data.body.token }),
                      success: (data) => {
                        console.log('savePersonalInfo update success', data);
                        if (data.body.success) {
                          this.editPersonalInfo();
                        }
                      },
                      error: (e) => {},
                    });
                  }
                  */
                },
                error: (e) => {},
              });
            }
          }
        },
        error: (e) => {},
      });
    },
    cancelPersonalInfo: function() {
      this.editPersonalInfo();
      this.personalInfo = [...this.personalInfoBuffer];
    },
    setNotification: function(notificationId, profileId) {
      let notification = !this.notification[notificationId];
      this.fetchRequest({
        url: this.updateProfile,
        form: this.form({
          [notificationId]: notification ? 1 : 0,
        }),
        success: (data) => {},
        error: (e) => {},
      });
    },
    form: function(data) {
      let _form = new FormData();
      Object.keys(data).forEach((item) => _form.append(item, data[item]));
      return _form;
    },
    phoneFormat: function({ target }) {
      this[this.type].phone = setPhoneFormat(target.value);
    },
    createPhone: function(value) {
      return resetPhoneFormat(value).slice(1);
    },
    setNewAddressPhone: function({ target }) {
      this.newAddressPhone = setPhoneFormat(target.value);
    },
    isEditAddressBlock: function(id) {
      return id == this.activeEditAdressBock;
    },
    clearNewAddress: function() {
      this.newAddress = '';
      this.newAddressComment = '';
      this.newAddressPhone = '';
    },
    onClearNewAddressError: function() {
      this.newAddressError = false;
    },
    onClearNewAddressPhoneError: function() {
      this.newAddressPhoneError = false;
    },
    isActiveInterface: function(id) {
      return id === this.activeEditAdressBock;
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeRouteEnter(to, from, next) {
    let products = document.querySelector('#personal');
    if (products) {
      products.remove();
    }

    let url = '/api/templates/personal';
    Vue.http.get(url, { params: to.query }).then((data) => {
      next((vm) => vm.setData(data));
    });
  },
  mounted() {
    setTimeout(() => {
      this.personalInfo = [...JSON.parse(this.$refs.loadname.innerText)];
      this.deliveryAddress = [...JSON.parse(this.$refs.address.innerText)];
      this.notification = { ...JSON.parse(this.$refs.notification.innerText) };
      Object.keys(this.$refs).forEach((item) =>
        this.$refs[item].parentNode.removeChild(this.$refs[item])
      );
    }, 0);
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement);
  },
};
export default PageComponent;



// WEBPACK FOOTER //
// ./src/templates/pages/personal/index.js